import { Component, OnInit } from '@angular/core';

import { AppPropertiesService } from '../services/app-properties/app-properties.service';

/**
 * Component for displaying the footer content.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-footer',
	standalone: true,
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
	aoLogoTaglineSrc: string;
	year: number;

	/**
	 * @param appPropertiesService the global app properties service
	 */
	constructor(private appPropertiesService: AppPropertiesService) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.aoLogoTaglineSrc = this.appPropertiesService.appProperties.aoLogoTaglineUrl ?? '';
		this.year = new Date().getFullYear();
	}
}
